import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import axios from 'axios';
import { BASE_API_URL } from '../../utils/constants';
import { myFirebaseAuth } from '../../firebase/config';
import { logoutUser } from './authService';

export const getSupplierSyncHistory = createAsyncThunk(
  'syncHistory/getSupplierSyncHistory',
  async (
    {
      supplierId,
      startDate,
      endDate,
    }: {
      supplierId: string;
      /** ISO instants; the server defaults to the last 7 days */
      startDate?: string;
      endDate?: string;
    },
    thunkApi
  ) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }
      const response = await axios.get<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/syncHistory/getSupplierSyncHistory`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
          params: { startDate, endDate },
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);
